import { httpClayStone } from "../../utils/http-claystone";

export const GetLocationSearch = (keyword: string) => {
  let params = {
    keyword: keyword,
  };
  return httpClayStone.get(
    `/api/1.0/resources/search/administrative`,
    params,
    true
  );
};
